import NewSelect from 'components/UI/NewSelect';
import React, { FC, useMemo } from 'react';
import { TSelectOptionsType } from 'domains/ReportBuilder/types';
import { Field, FieldProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { OptionProps } from 'react-select';
import Option from './Option';
import ValueContainer from './ValueContainer';
import MenuList from './MenuList';

type TReportSelectProps = {
  formikKey: string;
  options: TSelectOptionsType[];
  label: string;
  currentKey: string | null;
  isDisabled?: boolean;
  onCustomChange?: (value: string) => void;
  selectRef?: React.RefObject<any>;
  openedFilter?: string | null;
  setOpenedFilter?: React.Dispatch<React.SetStateAction<string | null>>;
  /** выводить заголовки и подзаголовки в каждом option */
  showSubtitleInOption?: boolean;
};

const ReportSelect: FC<TReportSelectProps> = ({
  formikKey,
  options,
  label,
  currentKey,
  isDisabled,
  onCustomChange,
  selectRef,
  openedFilter,
  setOpenedFilter,
  showSubtitleInOption,
}) => {
  const { t } = useTranslation();

  const controlsMenu = useMemo(() => {
    if (!setOpenedFilter) return {};

    return {
      menuIsOpen: openedFilter === currentKey,
      onMenuOpen: () => setOpenedFilter(currentKey),
      onBlur: () => setOpenedFilter(() => null),
      onFocus: () => setOpenedFilter(currentKey),
      onMenuClose: () =>
        setOpenedFilter((current) => (current === currentKey ? null : current)),
    };
  }, [currentKey, openedFilter, setOpenedFilter]);

  const customMenuList =
    currentKey && ['campaign', 'creative'].includes(currentKey)
      ? { MenuList }
      : {};

  return (
    <Field name={`reportFilters.${formikKey}.${currentKey}`}>
      {({ form, field }: FieldProps) => (
        <NewSelect
          label={label}
          selectRef={selectRef}
          customOptions={{
            Option: (
              props: OptionProps<TSelectOptionsType, boolean>,
            ): JSX.Element => (
              <Option
                {...(props as any)}
                showSubtitleInOption={showSubtitleInOption}
              />
            ),
            ValueContainer,
            ...customMenuList,
          }}
          form={form}
          field={field}
          selectAttributes={{
            isMulti: true,
            options,
            hideSelectedOptions: false,
            placeholder: t(`campaigns_page.create_campaign.enter`),
            isDisabled,
            value: options.filter((opt) =>
              (field.value || '').split(',').includes(opt.value),
            ),
            ...controlsMenu,
          }}
          viewStyle="Vertical"
          MultiValueRemove
          onCustomChange={onCustomChange}
        />
      )}
    </Field>
  );
};

export default ReportSelect;
